module.exports = __webpack_public_path__ + "img/w3_olja_grey.fc12b66b.png";